import {css} from 'lit';
export const styles = css`[cloak] {
  display: none !important;
}

/* Make sure to use CSS variables as much as possible to keep this component flexible! */
:host {
  --loader-min-height: 250px; /* Minimal height of the placeholder as long as the dynamically loader CSS/JS is not fully loaded */
  --frame-borderwidth--border-width-m: 2px;
  --color-neutrals--neutral-100: #f3f5f6;
}

/* I know .. "no CSS!!!" but hear me out!
 * This font definition must be present until we have a OCCL pre-set (bundle.css) that
 * injects this definition into the page.
 *
 * Currently we do not have this and thus this must stay (for occl).
 * It is taken verbatim from the MFE bundle.css.
 */
:host([theme='occl']) {
  font-weight: 400;
  font-size: 14px;
  line-height: 1.4;
  font-family: 'On Air', Verdana, Tahoma, sans-serif;
}
`;
export default styles;
